'use strict';

/**

 * 资源管理器

 * */

import EditorMD from './editormd';

import { loadScript, loadCss } from './utils';

export const loadedScripts = [];

export const loadedStyles = [];

/**

 * JQuery or Zepto

 * */

let promise$$: any = null;

export function loadJQueryOrZepto() {
    if ((window as any).jQuery || (window as any).Zepto) {
        return;
    }

    if (!promise$$) {
        // 加载

        // console.log('Setup Resource :: zepto.js');

        const url =
            'https://s3.cn-north-1.amazonaws.com.cn/files.datafountain.cn/forums/ajax/libs/zepto/1.2.0/zepto.min';

        promise$$ = loadScript(url).catch(() => {
            // console.error(`Fail to load "zepto.js" from origin "${url}"`);
        });
    }

    return promise$$;
}

/**

 * Prettify

 * */

let promisePR: any = null;

export function loadPrettify() {
    if ((window as any).PR) {
        return;
    }

    if ((window as any).PR) {
        return;
    }

    if (!promisePR) {
        // 加载代码美化脚本

        const baseUrl = EditorMD.resources.prettify.baseUrl;

        const prettifyUrl = `${baseUrl}/prettify`;

        // 加载并缓存

        console.log('Setup Resource :: prettify.js');

        promisePR = loadScript(prettifyUrl).catch(() => {
            console.error(`Fail to load "prettify.js" from origin "${prettifyUrl}"`);
        });
    }

    return promisePR;
}

/**

 * Katex

 * */

let promiseKatex: any = null;

export function loadKaTex() {
    if ((window as any).katex) {
        return;
    }

    if (!promiseKatex) {
        console.log('Setup Resource :: katex.js/css');

        // 加载代码美化脚本

        const baseUrl = EditorMD.resources.katex.baseUrl;

        const resUrl = `${baseUrl}/katex.min`;

        promiseKatex = Promise.all([
            loadCss(resUrl).catch(() => {
                console.error(`Fail to load "katex.min.js" from origin "${resUrl}"`);
            }),

            loadScript(resUrl).catch(() => {
                console.error(`Fail to load "katex.min.js" from origin "${resUrl}"`);
            }),
        ]);
    }

    return promiseKatex;
}

/**

 * CodeMirror Theme

 * */

const loadedThemes: {[key: string]: any} = {};

export function loadCodeMirrorTheme(theme: string) {
    if (loadedThemes[theme]) {
        return Promise.resolve(loadedThemes[theme]);
    }

    // 加载CodeMirror主题，组件默认只集成 default、material样式

    const baseUrl = EditorMD.resources.codemirror.baseUrl;

    const themeUrl = `${baseUrl}/theme/${theme}`;

    console.log('Setup Resource :: codemirror theme/' + theme);

    loadedThemes[theme] = loadCss(themeUrl).catch(() => {
        console.error(`Fail to load codemirror theme "${theme}" from origin "${themeUrl}"`);
    });

    return loadedThemes[theme];
}
